var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepcitylogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 27,
    viewBox: "0 0 147 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30748_166891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6203 21.182L88.4972 21.2017L87.4917 26.9755C84.8037 26.9705 82.2727 27.0591 79.624 26.9164C75.7343 26.705 72.2664 24.6837 70.3779 21.3443C68.6808 18.3443 68.5287 14.9853 69.235 11.6115C70.0591 7.68202 72.4479 4.1853 75.9697 2.2771C78.9324 0.67382 81.9588 0.0443115 85.201 0.0443115H92.2055L91.1803 5.85743L83.6707 5.9312C81.3064 5.95579 79.0795 7.09677 77.5688 8.84759C74.8268 12.0197 73.7134 18.4673 78.1426 20.464C79.1678 20.9263 80.3843 21.182 81.6252 21.182H81.6203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 0.059082L127.591 26.9706L120.076 26.9312L128.017 15.8902L122.249 0.059082H129.214L132.339 9.8558L139.427 0.0640001L147 0.059082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33 26.9705L104.159 26.9804L107.887 6.02956L101.005 5.98038L102.05 0.0492296L120.312 0.0443115L122.484 5.98038L114.058 6.00989L110.33 26.9705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4379 26.9361L89.2673 26.9705L94.0645 0.0491943L100.22 0.0590304L95.4379 26.9361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.936L2.5212 12.7131L14.3032 12.6541C16.7263 12.6393 18.3204 10.0672 17.9329 7.81963C17.6484 6.78685 16.8195 5.82291 15.6717 5.818L3.75728 5.78357L4.76773 0.0393066L16.9961 0.0688148C21.5823 0.0786509 24.7461 4.08685 24.1918 8.6016C23.4806 14.3606 18.3793 18.536 12.6207 18.5164L7.66172 18.5016L6.15096 26.9459H0V26.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5871 26.936L47.1083 12.7131L58.8903 12.6541C61.3134 12.6393 62.9075 10.0672 62.52 7.81963C62.2355 6.78685 61.4066 5.82291 60.2588 5.818L48.3444 5.78357L49.3597 0.0393066L61.588 0.0688148C66.1743 0.0786509 69.338 4.08685 68.7838 8.6016C68.0725 14.3606 62.9713 18.536 57.2127 18.5164L52.2537 18.5016L50.7429 26.9459H44.592L44.5871 26.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5276 16.2541L30.8284 16.2689L30.019 21.0049L43.7974 21.0246L42.7526 26.9459H22.7595L27.5518 0.0147541L47.177 0L46.1273 5.95082L32.653 5.97049L31.8879 10.377L44.5282 10.3967L43.5276 16.2541Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30748_166891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepcitylogo1);
export default __webpack_public_path__ + "static/media/PEPCITY LOGO 1.a5e4fb5d4e0b22a27f1566477e00e0f8.svg";
export { ForwardRef as ReactComponent };